import React, { Component } from 'react';
import { getTranslation } from '../../Utilities/GetTranslation';

declare var globalSns;
declare var globalExtranet;

class ExtranetBreadcrumb extends Component {
  constructor(props) {
    super(props);

    this.state = {
      index: 0
    }

    this.breadCrumbNavigate = this.breadCrumbNavigate.bind(this);
    this.goBack.bind = this.goBack.bind(this);
    this.goForward.bind = this.goForward.bind(this);
  }

  breadCrumbNavigate(row) {
    this.props.onNavigate(row.pageId, row.id, row.title);
  }

  goBack() {
    this.setState((prevState) => {
      return {
        index: prevState.index - 1
      }
    });
    window.history.back();
  }

  goForward() {
    if (this.state.index >= 0) {
      return;
    }

    this.setState((prevState) => {
      return {
        index: prevState.index + 1
      }
    });
    window.history.forward();
  }

  render() {
    if (this.props.menuitems.length < 2) {
      if (this.state.index !== 0) {
        this.setState({index: 0});
      }
      return <section id="breadcrumb" className="row breadcrumb"></section>;
    }

    return (
      <section id="breadcrumb" className="row breadcrumb">
        <div id="history">
          <a onClick={() => this.goBack() }><i className="fa fa-chevron-left"></i></a>
          <a onClick={() => this.goForward() } className={this.state.index < 0 ? "" : "disabled"}><i className="fa fa-chevron-right"></i></a>
        </div>
        <div id="breadcrumbs">
          {
            this.props.menuitems.map((x, i) => 
              <span key={x.pageId}>
                {
                  (i !== this.props.menuitems.length - 1) ?
                    <a onClick={(e) => this.breadCrumbNavigate(x)}>{i === 0 ? getTranslation("sns.general.extranet.home") : x.title}</a>  : 
                    <span className="CMSBreadCrumbsCurrentItem">{x.title}</span>
                }
                &nbsp;
                {
                  (i !== this.props.menuitems.length - 1) ?
                    <i className="fa fa-angle-right"></i> : ""
                }
                &nbsp;
              </span>
            )
          }
        </div>
      </section>
    );
  }
}

export default ExtranetBreadcrumb;


// WEBPACK FOOTER //
// ./src/Components/Extranet/ExtranetBreadcrumb.js